import { gql } from "@apollo/client";

export const NOTIFICACAO_FIELDS = gql`
  fragment NotificacaoFields on NotificacaoType {
    id
    tipo
    titulo
    mensagem
    lida
    dataLeitura
    entidadeTipo
    entidadeId
    metadata
    criadoEm
  }
`;
